import BaseServiceCrud from './BaseServiceCrud';

export default class TrailerService extends BaseServiceCrud {
	// Initializing important variables
	constructor() {
		super();
		this.path = 'trailer';
	}

	getCriteria(criteria) {
		return this.objToQueryString({
			number: criteria.number,
            type: criteria.type,
            own: criteria.own,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
		});
	}
	
	update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${element.sapId}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

	delete(element) {
        return this.fetch(`${this.domain}/${this.path}/${element.sapId}`, {
            method: 'DELETE',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
